module.exports = __webpack_public_path__ + "omniv2/img/icon-vehicle.9c8bd2d6.svg";